/**
 * UTILS JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise UTILS
         * Set sliders functions etc
         */
        console.log( 'UTILS - init' );
		
    },
	
	encodeHTMLEntities( str ) {
		//aon_craft_step_navigation.encodeHTMLEntities( str )
		return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	},
	
	removeHTMLTags( str ) {
		str = str.toString();
		// Regular expression to identify HTML tags and other common JavaScript function names in the input string. Replacing the identified string with an empty string.
		str = str.replace( 'setTimeout(', '' );
		str = str.replace( 'setInterval(', '' );
		str = str.replace( 'document.write(', '' );
		str = str.replace( 'document.getElementById(', '' );
		str = str.replace( 'window.open(', '' );
		str = str.replace( 'window.alert(', '' );
		str = str.replace( 'window.prompt(', '' );
		str = str.replace( 'window.confirm(', '' );
		str = str.replace( 'window.open (', '' );
		str = str.replace( 'window.alert (', '' );
		str = str.replace( 'window.prompt (', '' );
		str = str.replace( 'window.confirm (', '' );
		str = str.replace( 'open(', '' );
		str = str.replace( 'alert(', '' );
		str = str.replace( 'prompt(', '' );
		str = str.replace( 'confirm(', '' );
		str = str.replace( 'open (', '' );
		str = str.replace( 'alert (', '' );
		str = str.replace( 'prompt (', '' );
		str = str.replace( 'confirm (', '' );
		str = str.replace( 'onclick=', '' );
		str = str.replace( 'onclick', '' );
		str = str.replace( 'onfocus=', '' );
		str = str.replace( 'onfocus', '' );
		str = str.replace( 'autofocus=', '' );
		str = str.replace( 'autofocus', '' );
		str = str.replace( 'onblur=', '' );
		str = str.replace( 'onblur', '' );
		str = str.replace( 'eval(', '' );
		str = str.replace( 'eval (', '' );
		str = str.replace( 'addEventListener(', '' );
		str = str.replace( 'addEventListener (', '' );
		str = str.replace( 'addEventListener', '' );
		str = str.replace( '$.ajax(', '' );
		str = str.replace( ');', '' );
		return str.replace( /(<([^>]+)>)/ig, '');
	}

}